import Hidden from "@material-ui/core/Hidden";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import doctorateIconGlyph from "Assets/newicons/app/profile/glyph/doctorate-glyph-16px.svg";
import graduateIconGlyph from "Assets/newicons/app/profile/glyph/education-graduate-glyph-16px.svg";
import postGradIconGlyph from "Assets/newicons/app/profile/glyph/postgraduate-glyph-16px.svg";
import schoolIconGlyph from "Assets/newicons/app/profile/glyph/school-glyph-16px.svg";
import underGradIconGlyph from "Assets/newicons/app/profile/glyph/undergraduate-glyph-16px.svg";
import doctorateIconOutline from "Assets/newicons/app/profile/outline/doctorate-outline-16px.svg";
import graduateIconOutline from "Assets/newicons/app/profile/outline/education-graduate-outline-16px.svg";
import postGradIconOutline from "Assets/newicons/app/profile/outline/postgraduate-outline-16px.svg";
import schoolIconOutline from "Assets/newicons/app/profile/outline/school-outline-16px.svg";
import underGradIconOutline from "Assets/newicons/app/profile/outline/undergraduate-outline-16px.svg";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { profilePrivacyInfo } from "../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../Actions/LanguageAction";
import "../Profile.css";
import Doctorate from "./Doctorate";
import Graduate from "./Graduate";
import PostGraduate from "./PostGraduate";
import School from "./School";
import UnderGraduate from "./UnderGraduate";

class EducationTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabId: 0,
      educationtabs: [
        {
          label: <FormattedMessage id="Tabschool" defaultMessage="School" />,
          icon: <img src={schoolIconOutline} style={{ marginBottom: 0, marginRight:8}}></img>,
          id: 0,
          name: "school",
        },
        {
          label: (
            <FormattedMessage
              id="Tabundergraduate"
              defaultMessage="Under Graduate"
            />
          ),
          icon: (
            <img src={underGradIconOutline} style={{ marginBottom: 0 , marginRight:8}}></img>
          ),
          id: 1,
          name: "undergraduate",
        },
        {
          label: (
            <FormattedMessage id="Tabgraduate" defaultMessage="Graduate" />
          ),
          icon: (
            <img src={graduateIconOutline} style={{ marginBottom: 0 , marginRight:8}}></img>
          ),
          id: 2,
          name: "graduate",
        },
        {
          label: (
            <FormattedMessage
              id="Tabpostgraduate"
              defaultMessage="Post Graduate"
            />
          ),
          icon: (
            <img src={postGradIconOutline} style={{ marginBottom: 0 , marginRight:8}}></img>
          ),
          id: 3,
          name: "postgraduate",
        },
        {
          label: (
            <FormattedMessage id="TabDoctorate" defaultMessage="Doctorate" />
          ),
          icon: (
            <img src={doctorateIconOutline} style={{ marginBottom: 0 , marginRight:8}}></img>
          ),
          id: 4,
          name: "doctorate",
        },
      ],
      hideButton: false,
      employeeid: "",
    };

    this.handleMenuChange = this.handleMenuChange.bind(this);
    this.updatestrength = this.updatestrength.bind(this);
  }

  componentDidMount() {
    // let employeeid;
    // let SubscriptionInfo = createstore.getState().SubscriptionInfo;
    // employeeid = SubscriptionInfo.SubscriptionData.employeeid;
    // let AuthenticationAction = createstore.getState().AuthenticationAction;
    // if (AuthenticationAction.IsFulfilled) {
    //     employeeid = AuthenticationAction.login.employeeid;
    // }
    // let colleagueid = this.props.match.params.colleagueid;
    // let hideButton;
    // colleagueid && colleagueid != employeeid ? (hideButton = true) : (hideButton = false);
    // this.setState({ colleagueid, hideButton, employeeid }, () => {
    //     // this.GetPrivacyInfo();
    // });
  }

  handleMenuChange(selectedId) {
    let { educationtabs } = this.state;
    educationtabs = educationtabs.map((tab) => {
      if (tab.id == 0) {
        return {
          ...tab,
          icon:
            tab.id == selectedId ? (
              <img src={schoolIconGlyph} style={{ marginBottom: 0 ,marginRight:8}}></img>
            ) : (
              <img src={schoolIconOutline} style={{ marginBottom: 0 ,marginRight:8}}></img>
            ),
        };
      } else if (tab.id == 1) {
        return {
          ...tab,
          icon:
            tab.id == selectedId ? (
              <img src={underGradIconGlyph} style={{ marginBottom: 0 ,marginRight:8}}></img>
            ) : (
              <img src={underGradIconOutline} style={{ marginBottom: 0 ,marginRight:8}}></img>
            ),
        };
      } else if (tab.id == 2) {
        return {
          ...tab,
          icon:
            tab.id == selectedId ? (
              <img src={graduateIconGlyph} style={{ marginBottom: 0 ,marginRight:8}}></img>
            ) : (
              <img src={graduateIconOutline} style={{ marginBottom: 0 ,marginRight:8}}></img>
            ),
        };
      } else if (tab.id == 3) {
        return {
          ...tab,
          icon:
            tab.id == selectedId ? (
              <img src={postGradIconGlyph} style={{ marginBottom: 0 ,marginRight:8}}></img>
            ) : (
              <img src={postGradIconOutline} style={{ marginBottom: 0 ,marginRight:8}}></img>
            ),
        };
      } else if (tab.id == 4) {
        return {
          ...tab,
          icon:
            tab.id == selectedId ? (
              <img src={doctorateIconGlyph} style={{ marginBottom: 0 ,marginRight:8}}></img>
            ) : (
              <img src={doctorateIconOutline} style={{ marginBottom: 0,marginRight:8 }}></img>
            ),
        };
      }
    });
    this.setState({ tabId: selectedId, educationtabs });
  }

  updatestrength(flag) {
    if (flag == true) {
      this.props.UpdateStrength(true);
    }
  }

  render() {
    const { tabId } = this.state;
    const language = this.props.Language.emppersonaltab;
    return (
      <IntlProvider locale="en" messages={language}>
        <div
          className="vertical-tab-section"
          style={{ display: "flex", overflowY: Hidden, paddingLeft: 0 }}
        >
          <VerticalTabs
            value={tabId}
            indicatorColor="primary"
            textColor="primary"
            className="right-border width250 cursurpointer"
          >
            {this.state.educationtabs.map((tab) => (
              <MyTab
                label={tab.label}
                icon={tab.icon}
                onClick={() => this.handleMenuChange(tab.id)}
                className={
                  tab.id == 0
                    ? " var-tab-heading school"
                    : tab.id == 1
                    ? " var-tab-heading undergraduate"
                    : tab.id == 2
                    ? " var-tab-heading Graduate"
                    : tab.id == 3
                    ? " var-tab-heading PostGraduate"
                    : tab.id == 4
                    ? " var-tab-heading Doctorate"
                    : "var-tab-heading"
                }
              />
            ))}
          </VerticalTabs>

          <div
            style={{
              width: 5,
              height: 530,
              background: "#d3d3d3",
              position: "relative",
              left: -4,
              zIndex: -1,
            }}
          ></div>

          {this.state.tabId === 0 && (
            <TabContainer>
              <School {...this.props} UpdateStrength={this.updatestrength} />
            </TabContainer>
          )}

          {this.state.tabId === 1 && (
            <TabContainer>
              <UnderGraduate
                {...this.props}
                UpdateStrength={this.updatestrength}
              />
            </TabContainer>
          )}

          {this.state.tabId === 2 && (
            <TabContainer>
              <Graduate {...this.props} UpdateStrength={this.updatestrength} />
            </TabContainer>
          )}

          {this.state.tabId === 3 && (
            <TabContainer>
              <PostGraduate
                {...this.props}
                UpdateStrength={this.updatestrength}
              />
            </TabContainer>
          )}

          {this.state.tabId === 4 && (
            <TabContainer>
              <Doctorate {...this.props} UpdateStrength={this.updatestrength} />
            </TabContainer>
          )}
        </div>
      </IntlProvider>
    );
  }
}

const VerticalTabs = withStyles((theme) => ({
  flexContainer: {
    flexDirection: "column",
  },
  indicator: {
    display: "none",
  },
}))(Tabs);

const MyTab = withStyles((theme) => ({
  labelContainer: {
    padding: "6px 8px",
  },
  label: {
    color: "rgba(0, 0, 0, 0.87)",
  },
  icon: {
    display: "inline-black",
  },
}))(Tab);

function TabContainer(props) {
  return (
    <Typography
      component="div"
      className="verticaltab-innercont"
      style={{ overflow: "auto" }}
    >
      {props.children}
    </Typography>
  );
}

const mapStateToProps = (state) => ({
  profilePrivacyInfoReducer: state.profilePrivacyInfoReducer,
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      profilePrivacyInfo: (data) => profilePrivacyInfo(data),
      ChangeLanguage: (data) => ChangeLanguage(data),
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(EducationTab);
